import {React, useState, useEffect} from 'react';
import '../../App.css'
import axios from 'axios';
import { Grid, TextField, Box, Button,Paper, Stack,Typography} from '@mui/material';
import {PersonAddAlt1} from '@mui/icons-material';
import * as employeeService from '../../services/employeeService';
import Popup from '../Popup';
import DataTable from '../DataTable';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';
import { BiSave } from "react-icons/bi";

const options = employeeService.getDepartmentCollection();

const initialFValues={
  id: 0,
  regionCode: '',
  officeCode: '',
  ESTcodeNo: '',
  extention: '',
}

// Reusable component to add a red asterisk to a label
const RequiredLabel = ({ label }) => (  
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

function PF_DetailsForm(props){

  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [pfDetails, setPFDetails] = useState({});
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();


  const validate = () => {
    let temp = {};
    temp.regionCode = values.regionCode ? "" : "This field is required.";
    temp.officeCode = values.officeCode ? "" : "This field is required.";
    temp.ESTcodeNo = values.ESTcodeNo ? "" : "This field is required.";

    setErrors({
      ...temp
    });

    return Object.values(temp).every(x => x === "");
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
          ...errors,
          [name]: ''
      });
  }
  }

  useEffect(() => {
    async function getPFDetails(){
      if(props.fetch_id !== 9999) {
        try {
          const pfDetails =  await axios.get(`${process.env.REACT_APP_API_BASE_URL}/company-master/get-company-pf-details/` + props.fetch_id);
          setPFDetails(pfDetails.data[0]);

          const editFValues = {
            // initial : employees.data[0].initial,
            regionCode: pfDetails.data[0].region_code,
            officeCode: pfDetails.data[0].office_code,
            ESTcodeNo: pfDetails.data[0].est_code,
            extention: pfDetails.data[0].extension,
  
          }
          setValues(editFValues);


        } catch (e) {
          if(e.response.status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              navigate('/');
            },1000);
          }
        }
      } else {
        setValues(initialFValues)
      }
      }
    getPFDetails();

  },[]);


  const handleSubmit = (e) => {
    e.preventDefault();
    if(validate()) {
      let API_URL = '';
      if(props.fetch_id === 9999) {
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/company-master/add-company-pf-details`;
      } else {
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/company-master/edit-company-pf-details/` + props.fetch_id;
      }
      values.id = props.companyID;
      axios.post(API_URL, values)
      .then(function (response) {
        if(response.status === 200) {
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: 'success'
          });
        }
      })
      .catch(function (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      });
    }
  }

  return(
    <Box className="form-box" sx={{display: "flex" ,justifyContent: "center", margin: "-3px", padding: "50px", fontWeight: "500px"}}>
      <Paper elevation={5} sx={{width: "500px"}}>
        <Grid className="form-title" container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>PF Details</Typography> </Grid>
          <Grid item> <PersonAddAlt1 style={{marginLeft: "-30px"}}sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>

          <Stack spacing={2} sx={{margin: "30px"}}>

            <TextField
              variant="outlined"
              name="regionCode"
              label={<RequiredLabel label="Region Code"/>}
              size="small"
              value={values.regionCode}
              onChange={handleInputChange}
              {...(errors.regionCode && {error:true, helperText: errors.regionCode} )}
            />

            <TextField
              variant="outlined"
              name="officeCode"
              label={<RequiredLabel label="Office Code"/>}
              size="small"
              value={values.officeCode}
              onChange={handleInputChange}
              {...(errors.officeCode && {error:true, helperText: errors.officeCode} )}
            />

            <TextField
              variant="outlined"
              name="ESTcodeNo"
              label={<RequiredLabel label="Est Code No"/>}
              size="small"
              value={values.ESTcodeNo}
              onChange={handleInputChange}
              {...(errors.ESTcodeNo && {error:true, helperText: errors.ESTcodeNo} )}
            />

            <TextField
              variant="outlined"
              name="extention"
              label="Extension If Any"
              size="small"
              value={values.extention}
              onChange={handleInputChange}
              {...(errors.extention && {error:true, helperText: errors.extention} )}
            />


            <Grid container className="form-btn-container">
                {/* <Grid item>
                  <Button variant="outlined" color="secondary" onClick={() => setOpenPopup(true)}>Previous</Button>
                </Grid> */}
                <Grid item>
                  {/* <Button variant="outlined" color="primary" >Add</Button> */}
                </Grid>
                <Grid item>
                  <Button variant="outlined" color="success" endIcon={<BiSave/>} type="submit">Save</Button>
                </Grid>
                <Grid item>
                  {/* <Button variant="outlined" color="success" >Cancel</Button> */}
                </Grid>
            </Grid>

            </Stack>
        </form>

        {/* <Button className="form-btn" variant="outlined" color="error" onClick={() => setOpenPopup(true)} startIcon={<Preview sx={{width: "30px", height: "30px"}}/>} >Show</Button> */}

        <Popup
        title="Employee Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <DataTable/>
        </Popup>
      </Paper>
      <Notification
            notify={notify}
            setNotify={setNotify} />
    </Box>
  )
}

export default PF_DetailsForm;
